import ApiService from '@/core/services/api.service';
import { handleError } from '@/utils/common';

const state = {
  categories: [],
  isLoading: false,
  error: null,
  totalRows: 0,
  currentPage: 1,
  itemsPerPage: 10,
};

const getters = {
  getCategories: (state) => state.categories,
  isLoading: (state) => state.isLoading,
  getError: (state) => state.error,
  getTotalRows: (state) => state.totalRows,
  getCurrentPage: (state) => state.currentPage,
  getItemsPerPage: (state) => state.itemsPerPage,
};

const mutations = {
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_TOTAL_ROWS(state, totalRows) {
    state.totalRows = totalRows;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
};

const actions = {
  async getCategories({ commit }, { page = 1, keyword = '', pageSize = 10 }) {
    commit('SET_LOADING', true);

    try {
      const response = await ApiService.query('v1/installments/all', {
        params: { page, keyword, pageSize },
      });

      const items = response.data.data.items || response.data.data.data || [];
      const totalItems =
        response.data.data.totalItems || response.data.data.totalItems || 0;

      commit('SET_CATEGORIES', items);
      commit('SET_TOTAL_ROWS', totalItems);
      commit('SET_CURRENT_PAGE', page);
      commit('SET_ERROR', null);

      return response.data;
    } catch (error) {
      handleError(error);
      commit('SET_ERROR', error.message || 'Lỗi khi tải danh sách danh mục');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async getCategoryById({ commit }, id) {
    commit('SET_LOADING', true);

    try {
      const response = await ApiService.get(`v1/installments/${id}`);
      commit('SET_ERROR', null);

      return response.data;
    } catch (error) {
      handleError(error);
      commit('SET_ERROR', error.message || 'Lỗi khi tải thông tin danh mục');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createCategory({ commit, dispatch }, categoryData) {
    commit('SET_LOADING', true);

    try {
      const response = await ApiService.post('v1/installments', categoryData);
      commit('SET_ERROR', null);

      await dispatch('getCategories', { page: 1 });

      return response.data;
    } catch (error) {
      handleError(error);
      commit('SET_ERROR', error.message || 'Lỗi khi tạo danh mục');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateCategory({ commit, dispatch }, { id, ...categoryData }) {
    commit('SET_LOADING', true);

    try {
      const response = await ApiService.put(
        `v1/installments/${id}`,
        categoryData,
      );
      commit('SET_ERROR', null);

      await dispatch('getCategories', { page: state.currentPage });

      return response.data;
    } catch (error) {
      handleError(error);
      commit('SET_ERROR', error.message || 'Lỗi khi cập nhật danh mục');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async deleteCategory({ commit, dispatch }, id) {
    commit('SET_LOADING', true);

    try {
      const response = await ApiService.delete(`v1/installments/${id}`);
      commit('SET_ERROR', null);

      await dispatch('getCategories', { page: state.currentPage });

      return response.data;
    } catch (error) {
      handleError(error);
      commit('SET_ERROR', error.message || 'Lỗi khi xóa danh mục');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
